export const isBase64 = (str) => {
    try {
        return window.btoa(window.atob(str)) === str;
    } catch (error) {
        return false;
    }
};